require('./pallet');
require('./box');
require('./batch');
require('./spool');
require('./accordion');
require('./label-printer');


$(document).ready(() => {
    $('.product-sales_order-container').fnProduction();
});

(function ($) {
    /**
     *
     * @returns {*}
     */
    $.fn.fnProduction = function () {
        /**
         *
         */
        return this.each(function () {
            let production = this;

            production.batchId = null;
            production.batchName = null;
            production.btnNewPallet = null;
            production.code = null;
            production.customerCode = null;
            production.itemNumber = null;
            production.labelPrinterBox = null;
            production.labelPrinterSpool = null;
            production.labelSettingsBox = null;
            production.labelSettingsSpool = null;
            production.pallets = new Set();
            production.palletsContainer = null;
            production.pid = null;
            production.productId = null;
            production.productConversionKgM = null;
            production.salesOrderId = null;
            production.salesOrderLineId = null;
            production.palletsTitle = null;
            production.labelPrinter = null;
            production.packagingMode = null;
            production.boxOnly = null;
            production.picked = false;

            /**
             *
             */
            production.init = () => {
                production.initData();
                production.initElements();
                production.initButtons();
                production.setData();
                production.postInit();
            }

            /**
             *
             */
            production.initData = () => {
                production.batchId = $(production).attr('data-batch-id');
                production.batchName = $(production).attr('data-batch-name');
                production.customerCode = $(production).attr('data-customer-code');
                production.itemNumber = $(production).attr('data-item-number');
                production.code = $(production).attr('data-code');
                production.pid = $(production).attr('data-pid');
                production.productId = parseInt($(production).attr('data-product'));
                production.productConversionKgM = $(production).attr('data-product-conversion_kg_m') ?? null;
                production.salesOrderId = parseInt($(production).attr('data-sales-order'));
                production.salesOrderLineId = parseInt($(production).attr('data-sales-order-line'));
                production.labelPrinterBox = $(production).attr('data-label-printer-box');
                production.labelPrinterSpool = $(production).attr('data-label-printer-spool');
                production.labelSettingsBox = JSON.parse($(production).attr('data-label-settings-box'));
                production.labelSettingsSpool = JSON.parse($(production).attr('data-label-settings-spool'));
                production.packagingMode = $(production).attr('data-packaging-mode');
                production.boxOnly = $(production).attr('data-box-only') === 'true';
                production.picked = $(production).attr('data-picked') === 'true';
            }

            /**
             *
             */
            production.initElements = () => {
                production.btnNewPallet = $('button.new-pallet', $(production));
                production.palletsContainer = $('div.production-pallets', $(production));
                production.palletsTitle = $('div.pallets-title', $(production));
                production.labelPrinter = $(production).fnLabelPrinter();
            }

            /**
             *
             */
            production.initButtons = () => {
                production.btnNewPallet.off('click keydown').on('click keydown', () => {
                    production.newPallet();
                    window.blur();
                });
            }

            /**
             *
             */
            production.postInit = () => {
                production.accordion = $(this).productionAccordion(
                    production.palletsTitle,
                    $('.production-pallets', $(production))
                );
            }

            /**
             *
             * @returns {{product_id: *, sales_order_id: *}}
             */
            production.getData = () => {
                return {
                    product_id: production.getProductId(),
                    sales_order_id: production.getSalesOrderId(),
                    sales_order_line_id: production.getSalesOrderLineId(),
                };
            }

            /**
             *
             */
            production.newPallet = (data = null) => {
                production.pallets.forEach((pallet) => {
                    pallet.showTitle();
                    pallet.accordion.close();
                });
                let template = $('#pallet-template').html();
                let newElement = $(template).appendTo(production.palletsContainer);
                production.pallets.add(newElement.productionPallet(this, data));
                $('span.content-emballage', production.btnNewPallet).hide();
                $('span.content-pallet', production.btnNewPallet).show();
            }

            /**
             *
             * @returns {null|*}
             */
            production.getBatchId = () => {
                return production.batchId;
            }

            /**
             *
             * @returns {null|*}
             */
            production.getBatchName = () => {
                return production.batchName;
            }

            /**
             *
             * @returns {Set<any>}
             */
            production.getBoxes = () => {
                let boxes = new Set();
                production.pallets.forEach(function (pallet) {
                    pallet.boxes.forEach(function (box) {
                        boxes.add(box);
                    });
                });
                return boxes;
            }

            /**
             *
             * @returns {null|*}
             */
            production.getCode = () => {
                return production.code;
            }

            /**
             *
             * @returns {null|*}
             */
            production.getCustomerCode = () => {
                return production.customerCode;
            }

            /**
             *
             * @param type
             * @returns {null|*|null}
             */
            production.getLabelPrinter = (type) => {
                switch (type) {
                    case 'box':
                        return production.labelPrinterBox;
                    case 'spool':
                        return production.labelPrinterSpool;
                    default:
                        return null;
                }
            }

            /**
             *
             * @returns {null|*}
             */
            production.getPid = () => {
                return production.pid;
            }

            /**
             *
             * @returns {*}
             */
            production.getProductId = () => {
                return production.productId;
            }

            /**
             *
             * @returns {*}
             */
            production.getSalesOrderId = () => {
                return production.salesOrderId;
            }

            /**
             *
             * @returns {*}
             */
            production.getSalesOrderLineId = () => {
                return production.salesOrderLineId;
            }

            /**
             *
             * @param type
             * @param printer
             * @returns {null|*|null}
             */
            production.setLabelPrinter = (type, printer) => {
                switch (type) {
                    case 'box':
                        production.labelPrinterBox = printer;
                        break;
                    case 'spool':
                        production.labelPrinterSpool = printer;
                        break;
                    default:
                        break;
                }
            }

            /**
             *
             * @param type
             * @returns {null|*|null}
             */
            production.getLabelSettings = (type) => {
                switch (type) {
                    case 'box':
                        return production.labelSettingsBox;
                    case 'spool':
                        return production.labelSettingsSpool;
                    default:
                        console.error('getLabelSettings: [' + type + '] not known');
                        return null;
                }
            }

            /**
             *
             * @returns {Set<any>}
             */
            production.getPallets = () => {
                return production.pallets;
            }

            /**
             *
             */
            production.setData = () => {
                let data = $('#sales-orders-packaging').val();
                let packaging = JSON.parse(data);
                $.each(packaging.pallets, function (foo, pallet) {
                    production.newPallet(pallet);
                });
            }

            /**
             *
             * @param palletToRemove
             */
            production.deletePallet = (palletToRemove) => {
                production.pallets.forEach((pallet) => {
                    if (pallet === palletToRemove) {
                        pallet.remove();
                        production.pallets.delete(pallet);
                    }
                })
            }

            production.init();

            return production;
        })[0];
    }

}(jQuery));
